var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(" " + _vm._s(_vm.$t("entities.fieldManager.plural")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.fieldManager.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.add")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("table.history")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list)
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n         " +
                          _vm._s(_vm.$t("table.export")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no managers yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-dropdown-link",
                            attrs: { size: "small", round: "" }
                          },
                          [_c("i", { staticClass: "el-icon-more" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _vm.hasRoleToRead
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-search",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.show(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.details")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToUpdate
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-pencil-square-o",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.edit(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.edit")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToDelete
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-trash",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.destroy(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.delete")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e52d8fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e52d8fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/field-manager/field-manager-list.vue
// module id = null
// module chunks = 